import React from 'react'
import Select from 'react-select'
import DisplayQuickShipIndicator from '../../catalog/rectangleResult/displays/DisplayQuickShipIndicator'
import { getProductTitle } from '../../orders/new-order-history/Utils'
import Translation from '../../global/Translation'
import cityIcon from '../../../assets/img/icons/city.svg'
import Alerts from '../../alerts/Alerts'
import { connect } from 'react-redux'
import { setShippingAddressType } from '../../../store/checkout/actions'

const SHIPPING_CENTER = 'S_CENTER'
const SHIPPING_CUSTOM = 'S_CUSTOM'
const SHIPPING_NONE = 'S_NONE'

class ShippingSelector extends React.Component {
    state = {
        selectedShipping: !!this.props.splittedLocalCtsLines ? SHIPPING_CUSTOM : null
    }

    componentDidMount() {
        this.props.setShippingAddressType(this.state.selectedShipping)
    }

    componentWillUnmount() {
        this.props.setShippingAddressType(null)
    }

    getOptionsCountryOfSend = filteredShippingAddressesForUsers => {
        if (filteredShippingAddressesForUsers)
            return filteredShippingAddressesForUsers.map(shippingAddress => ({
                value: shippingAddress.ecosentinoKey,
                label:
                    shippingAddress.centerName +
                    ' ' +
                    shippingAddress.customerName +
                    ' ' +
                    shippingAddress.address +
                    ' ' +
                    shippingAddress.zipCode +
                    ' ' +
                    shippingAddress.city +
                    ' ' +
                    shippingAddress.country +
                    ' ' +
                    shippingAddress.salesOrg
            }))
        else return []
    }

    CustomRadio = (name, label, shippingValue) => {
        return (
            <label className="custom-radio">
                <input type="radio" name="delivery" checked={this.state.selectedShipping === shippingValue} onClick={() => this.setShipping(shippingValue)} readOnly />
                <span className="radio-mark"></span>
                <span className="radio-text">{label}</span>
            </label>
        )
    }

    DeliveryOption = () => {
        return (
            <div className="delivery-options">
                {/* Opción 1: Delivery */}
                <div className={`delivery-option-container${this.state.selectedShipping === SHIPPING_CUSTOM ? ' selected' : ''}`}>
                    {this.CustomRadio(
                        'delivery',
                        <Translation id="delivery_to_default_address" defaultMessage="Delivery to your default address" />,
                        SHIPPING_CUSTOM
                    )}

                    <div className="delivery-option-content">
                        <div className="delivery-option-content-desc">
                            <Translation id="select_default_address" defaultMessage="Select the default address:" />
                        </div>

                        {this.ShippingAddressSelect()}
                    </div>
                </div>

                {/* Opción 2: Pickup */}
                <div className={`delivery-option-container${this.state.selectedShipping === SHIPPING_CENTER ? ' selected' : ''}`}>
                    {this.CustomRadio(
                        'delivery',
                        <React.Fragment>
                            <Translation id="pickup_at_center" defaultMessage="Pickup at Center" />:
                            &nbsp;{this.props.centerAddress.name}
                        </React.Fragment>,
                        SHIPPING_CENTER
                    )}
                    <div className="delivery-option-content">
                        <div className="delivery-option-content-center">
                            <span style={{ marginRight: 6 }}>
                                <img alt="" src={cityIcon} />
                            </span>
                            {this.props.centerAddress.address}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    ShippingAddressSelect = () => {
        const filteredShippingAddressesForUsers = this.props.shippingAddresses
            ? this.props.shippingAddresses.filter(shippingAddress => {
                  if (this.props.isMallCartForContainer) return shippingAddress.allowedShippingTypes.includes('SINGLE_SLAB')
                  return shippingAddress.allowedShippingTypes.includes(this.props.shippingMethod)
              })
            : []

        let destinationForCustomer = [
            { value: 'CLIENTE', label: this.props.intl.formatMessage({ id: 'customer' }) },
            {
                value: 'HUB_CLIENTE',
                label: this.props.intl.formatMessage({ id: 'cosentino_hub' })
            },
            {
                value: 'CENTER',
                label: this.props.intl.formatMessage({ id: 'center' })
            }
        ]
        if (this.props.isMallCartForContainer && this.props.current <= this.props.goalMin) {
            destinationForCustomer = [
                {
                    value: 'HUB_CLIENTE',
                    label: this.props.intl.formatMessage({ id: 'cosentino_hub' })
                }
            ]
        }

        return (
            <div className="mb-3">
                {this.props.hasDestination && !this.props.isShippingTypeContainerWhenIreland && (
                    <div className={`form-group select`}>
                        <Select
                            className={'form-control '}
                            placeholder={this.props.intl.formatMessage({ id: 'select_shipping_address' }) + '...'}
                            value={this.props.destination}
                            onChange={e => {
                                e && this.props.setDestination(e.value)
                            }}
                            options={destinationForCustomer}
                        />
                    </div>
                )}
                {(this.props.shippingAddresses || this.props.destination === 'CENTER') && (
                    <div className="form-group select">
                        <Select
                            id="checkout__select_shipping_address-default"
                            className="form-control"
                            disabled={this.state.selectedShipping !== SHIPPING_CUSTOM || this.props.endiSelectedShippingAddressId}
                            placeholder={`${this.props.intl.formatMessage({ id: 'select_shipping_address' })}...`}
                            value={
                                !this.props.endiSelectedShippingAddressId
                                    ? this.props.selectedShippingAddress
                                        ? this.props.selectedShippingAddress.ecosentinoKey
                                        : null
                                    : this.props.endiSelectedShippingAddressId
                            }
                            onChange={e => {
                                e && this.props.changeShippingAddress(e.value)
                            }}
                            options={
                                !this.props.endiSelectedShippingAddressId
                                    ? this.getOptionsCountryOfSend(filteredShippingAddressesForUsers)
                                    : this.getOptionsCountryOfSend(filteredShippingAddressesForUsers).filter(e => e.value === this.props.endiSelectedShippingAddressId)
                            }
                            clearable={false}
                        />
                    </div>
                )}
            </div>
        )
    }

    setShipping = shipping => {
        this.setState({ selectedShipping: shipping })
        this.props.setShippingAddressType(shipping)
    }

    render() {
        if (this.props.splittedLocalCtsLines) {
            return (
                <div className="shipping-selector">
                    <div className="shipping-selector-desc">
                        <strong><Translation id="choose_shipping_pickup_option" defaultMessage="Choose one of the available shipping or pickup options." /></strong>
                        &nbsp;
                        <Translation id="shipping_cost_disclaim" defaultMessage="The shipping cost will be updated in your order summary based on your selection." />
                    </div>
                    {this.DeliveryOption()}
                </div>
            )
        } else return <React.Fragment>{this.ShippingAddressSelect()}</React.Fragment>
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setShippingAddressType: (value) => dispatch(setShippingAddressType(value))
    }
}

export default connect(null, mapDispatchToProps)(ShippingSelector)
